import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Sun, Coins, Check } from 'lucide-react';
import { CheckinModal } from './CheckinModal';
import { useAuth } from '@/contexts/AuthContext';
import { activitiesAPI } from '@/lib/api';

export function CheckinCard() {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [completedToday, setCompletedToday] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      checkTodayStatus();
    }
  }, [user]);

  const checkTodayStatus = async () => {
    try {
      const response = await activitiesAPI.getCheckinToday();
      setCompletedToday(response.data.completed_today);
    } catch (error) {
      console.error('Failed to check checkin status:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleComplete = () => {
    setCompletedToday(true);
    setShowModal(false);
  };

  if (loading || !user) return null;

  // Se já fez check-in hoje, mostrar versão compacta
  if (completedToday) {
    return (
      <Card className="bg-green-50 border border-green-200">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-green-100 rounded-full">
              <Check className="h-5 w-5 text-green-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-green-800">
                Check-in de hoje feito!
              </p>
              <p className="text-xs text-green-600">
                Volte amanhã para mais tokens 💪
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <>
      <Card className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <Sun className="h-6 w-6 text-amber-600" />
            </div>
            <div className="flex-1">
              <h4 className="font-semibold text-amber-900 mb-1">
                Check-in Diário
              </h4>
              <p className="text-sm text-gray-600 mb-3">
                Como você está se sentindo hoje?
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs flex items-center gap-1 text-amber-600">
                  <Coins className="h-3 w-3" />
                  +5 tokens AWA
                </span>
                <Button
                  size="sm"
                  onClick={() => setShowModal(true)}
                  className="bg-amber-500 hover:bg-amber-600"
                >
                  Fazer Check-in
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <CheckinModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onComplete={handleComplete}
      />
    </>
  );
}
